import React from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center', // по вертикали
  },

  tableText: {
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})
const SummaryTournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  isFinish,
  protocolAData,
  protocolBData,
  protocolCData,
}) => {
  return (
    <Document style={{ margin: 0 }} scale={0.9}>
      <Page
        size="A4"
        style={{
          paddingBottom: 30,
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 20,
          fontFamily: 'Roboto',
        }}
      >
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>

        <Text
          style={{
            fontSize: 12,

            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          {isFinish
            ? 'СВОДНЫЙ ПРОТОКОЛ СОРЕВНОВАНИЙ'
            : 'СВОДНЫЙ ПРОТОКОЛ СОРЕВНОВАНИЙ'}
        </Text>

        {/* Таблица результатов */}
        <View>
          <View
            style={{
              width: '100%',
              borderStyle: 'solid',
              borderWidth: 0.3,
              borderColor: '#000',
            }}
          >
            <View
              style={{
                height: '40px',
                flexDirection: 'row',
                alignItems: 'stretch', // важно!
              }}
            >
              <View style={[styles.tableColHeader, { width: '5%' }]}>
                <Text style={styles.tableText}>Место</Text>
              </View>

              <View style={[styles.tableColHeader, { width: '45%' }]}>
                <Text style={[styles.tableText, { textAlign: 'left' }]}>
                  {' '}
                  Команда
                </Text>
              </View>
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>Сектор</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '10%' }]}>
                <Text style={styles.tableText}>По количеству</Text>
              </View>

              <View style={[styles.tableColHeader, { width: '10%' }]}>
                <Text style={styles.tableText}>По пяти рыбам</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '10%' }]}>
                <Text style={styles.tableText}>По BigFish</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '12%' }]}>
                <Text style={styles.tableText}>Сумма баллов</Text>
              </View>
            </View>
          </View>

          {data.map((item, index) => (
            <View key={index} wrap={false}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'stretch', // важно для одинаковой высоты 8FBC8F
                  backgroundColor:
                    item.finalRank < 4
                      ? '#fff'
                      : item.finalRank === 0
                        ? '#fff'
                        : '#fff',
                }}
              >
                <View style={[styles.tableColHeader, { width: '5%' }]}>
                  <Text style={styles.tableText}>
                    {item.finalRank % 1 === 0
                      ? item.finalRank
                      : item.finalRank.toFixed(1)}
                  </Text>
                </View>

                <View
                  style={[
                    styles.tableColHeader,
                    { width: '45%', alignItems: 'flex-start' },
                  ]}
                >
                  <Text style={[styles.tableText, { textAlign: 'left' }]}>
                    <Text style={{ fontWeight: 'bold' }}>{item.teamName}</Text>
                    {'\n'}
                    {item.sp}
                  </Text>
                </View>
                <View style={[styles.tableColHeader, { width: '8%' }]}>
                  <Text style={styles.tableText}>{item.sector}</Text>
                </View>

                <View style={[styles.tableColHeader, { width: '10%' }]}>
                  <Text style={styles.tableText}> {item.scoreA}</Text>
                </View>
                <View style={[styles.tableColHeader, { width: '10%' }]}>
                  <Text style={styles.tableText}> {item.scoreB}</Text>
                </View>
                <View style={[styles.tableColHeader, { width: '10%' }]}>
                  <Text style={styles.tableText}> {item.scoreC}</Text>
                </View>
                <View style={[styles.tableColHeader, { width: '12%' }]}>
                  <Text style={[styles.tableText, { fontWeight: 'bold' }]}>
                    {item.totalScore}
                  </Text>
                </View>

                {/* <Text
                  style={{ width: '20%', fontSize: 7, textAlign: 'center' }}
                >
                  {item.disqualified
                    ? 'Снята'
                    : item.isTie
                      ? 'Деление мест'
                      : ''}
                </Text> */}
              </View>
            </View>
          ))}
        </View>

        {/* Подписи */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 30,
          }}
        >
          {administrator.map((admin, i) => (
            <View
              key={i}
              style={{
                width: '45%',
                borderTop: '1px solid #000',
                paddingTop: 2,
              }}
            >
              <Text style={{ fontSize: 8, textAlign: 'center' }}>
                {admin.surname} {admin.name} {admin.patronymic} ({admin.role},{' '}
                {admin.rank})
              </Text>
            </View>
          ))}
        </View>

        {/* Логотипы спонсоров */}
        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default SummaryTournamentProtocolPDF
